import {useTranslation} from 'react-i18next';

/** Spread onto a field to show it read-only with a lock and the reason on hover. */
export interface FieldLock {
  isLocked: boolean;
  lockedTooltip?: string;
}

/** Identity fields stay visible but read-only once locked; their rules apply only while editable. */
export function useIdentityLock(isLocked: boolean, lockedTooltip?: string) {
  const {t} = useTranslation('trustAccounts');

  return {
    identityLock: {
      isLocked,
      lockedTooltip: lockedTooltip ?? t('view.buyers.editBuyerModal.lockedTooltip')
    },
    // Stored identity isn't re-validated once locked, so legacy values never block contact edits.
    whenEditable: <T>(rule: T): T | undefined => (isLocked ? undefined : rule)
  };
}
